import classNames from "classnames";
import * as React from "react";

import styles from "./Callout.module.css";

export type CalloutVariant = "info" | "warning" | "error" | "neutral";

export interface CalloutProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  /** What kind of message it is, as a colour. Defaults to `info`. */
  variant?: CalloutVariant;
  /** A bold first line. */
  title?: React.ReactNode;
  /** Drawn under the message, e.g. a button. */
  action?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * A boxed message inline with the page: something went wrong, needs care, or
 * is worth knowing. An `error` is announced as an alert; the rest are notes.
 */
export const Callout = React.forwardRef<HTMLDivElement, CalloutProps>(
  function Callout(
    { variant = "info", title, action, className, children, ...props },
    ref,
  ) {
    return (
      <div
        ref={ref}
        role={variant === "error" ? "alert" : "note"}
        {...props}
        className={classNames(styles.callout, className)}
        data-variant={variant}
      >
        {title !== undefined && <p className={styles.title}>{title}</p>}
        {children !== undefined && (
          <div className={styles.body}>{children}</div>
        )}
        {action !== undefined && <div className={styles.action}>{action}</div>}
      </div>
    );
  },
);
